export default "__VITE_ASSET__DiIb367i__"